/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

/* eslint-disable import/no-unresolved, import/default */

import kvListTemplate from './kv-list.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('tektelic.components.kvList', [])
    .directive('tkKvList', KvList)
    .name;

/*@ngInject*/
function KvList() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            disabled:'=ngDisabled',
            titleText: '@',
            kvList: '='
        },
        controller: KvListController,
        controllerAs: 'vm',
        templateUrl: kvListTemplate
    };
}

/*@ngInject*/
function KvListController() {

    let vm = this;

    vm.$onInit = function () {
        vm.removeKeyVal = removeKeyVal;
        vm.addKeyVal = addKeyVal;
    };

    function removeKeyVal(index) {
        if (index > -1) {
            vm.kvList.splice(index, 1);
        }
    }

    function addKeyVal() {
        if (!vm.kvList) {
            vm.kvList = [];
        }
        vm.kvList.push(
            {
                key: '',
                value: ''
            }
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/kv-list.directive.js